import { STEP } from "#src/constants/step.ts";
import {
  defineStore,
  generateInitialState,
  resetState,
} from "#src/stores/state-wrapper.ts";

import { useFlowStore } from "#src/stores/flow.ts";
import { useStepNameStore } from "#src/stores/step-name.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { computed } from "vue";
import {
  type BaseStepStoreState,
  type BaseStepStore,
} from "#src/types/StepStore.ts";

interface CalculatorState extends BaseStepStoreState {}

interface CalculatorStep extends BaseStepStore {
  setStepRequirements(): void;
}

function initialState(): CalculatorState {
  return {
    inactive: false,
  };
}

function initializeCalculatorStep(pinia: Pinia): CalculatorStep {
  const state = generateInitialState<CalculatorState>(initialState());

  function $reset() {
    resetState<CalculatorState>(state, initialState());
  }

  const step = computed(() => STEP.CALCULATOR);
  const next = computed(() => {
    const name = useStepNameStore(pinia);
    return name.step;
  });
  const previous = computed(() => null);
  const hidesFooter = computed(() => true);
  const controlsNext = computed(() => true);
  const hidesHeader = computed(() => true);

  function setStepRequirements() {
    const flow = useFlowStore(pinia);
    state.inactive.value = !flow.initialStepIsCalculator;
  }
  return {
    ...state,
    $reset,
    step,
    next,
    previous,
    hidesFooter,
    controlsNext,
    hidesHeader,
    setStepRequirements,
  };
}

export const useStepCalculatorStore = (pinia: Pinia, hot?: StoreGeneric) => {
  return defineStore<string, CalculatorStep>("step-calculator", () => {
    return initializeCalculatorStep(pinia);
  })(pinia, hot);
};
